import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";

import {AppRoutingModule} from './app-routing.module';
import {MaterialModule} from './material/material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';
import {NumericDirective} from "./numeric.directive";
import {LOCAL_STORAGE} from "ngx-webstorage-service";
import {LazyLoadDirective} from './lazy-load.directive';
//import {IvyCarouselModule} from 'angular-responsive-carousel'
import {MatPaginatorModule} from '@angular/material/paginator';
import {HomeComponent} from './components/home/home.component';
import {ExternalLinkDirective} from "./external-link.directive";
import {LoginComponent} from './components/login/login.component';
import {AddCvComponent} from './components/add-cv/add-cv.component';
import {NavbarComponent} from './components/navbar/navbar.component';
import {FooterComponent} from './components/footer/footer.component';
import {RouteDialogComponent} from './helpers/route-dialog.component';
import {AdComponent} from './components/company-stand/ad/ad.component';
import {USER_SERVICE_STORAGE} from "./services/authentication.service";
import {HistoryComponent} from './components/history/history.component';
import {AboutUsComponent} from './components/about-us/about-us.component';
import {HttpInterceptorService} from "./services/http-interceptor.service";
import {RegisterComponent} from './components/register/register.component';
import {LecturesComponent} from './components/lectures/lectures.component';
import { CatalogueComponent } from './components/catalogue/catalogue.component';
import {SupportersComponent} from './components/supporters/supporters.component';
import {OrganisersComponent} from "./components/organisers/organisers.component";
import {InjectDialogComponent} from './components/inject-dialog/inject-dialog.component';
import {CompanyStandComponent} from './components/company-stand/company-stand.component';
import {PasswordResetComponent} from './components/password-reset/password-reset.component';
import {PasswordChangeComponent} from './components/password-change/password-change.component';
import {CompanyDashboardComponent} from './components/company-dashboard/company-dashboard.component';
import {AddCvLangDialogComponent} from './components/add-cv/add-cv-lang-dialog/add-cv-lang-dialog.component';
import {DeleteCvLangDialogComponent} from './components/add-cv/delete-cv-lang-dialog/delete-cv-lang-dialog.component';
import { AdsComponent } from './components/ads/ads.component';
import { AdCardComponent } from './components/ads/ad-card/ad-card.component';
import { ScrollToTopComponent } from './components/backtotop/backtotop.component'

@NgModule({
    declarations: [
        AdComponent,
        AppComponent,
        HomeComponent,
        LoginComponent,
        AddCvComponent,
        NavbarComponent,
        FooterComponent,
        AboutUsComponent,
        HistoryComponent,
        NumericDirective,
        LecturesComponent,
        RegisterComponent,
        LazyLoadDirective,
        CatalogueComponent,
        SupportersComponent,
        OrganisersComponent,
        RouteDialogComponent,
        CompanyStandComponent,
        InjectDialogComponent,
        ExternalLinkDirective,
        PasswordResetComponent,
        PasswordChangeComponent,
        AddCvLangDialogComponent,
        DeleteCvLangDialogComponent,
        CompanyDashboardComponent,
        AdsComponent,
        AdCardComponent,
        ScrollToTopComponent,
    ],
    imports: [
        FormsModule,
        BrowserModule,
        MaterialModule,
        AppRoutingModule,
        HttpClientModule,
        //IvyCarouselModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        BrowserAnimationsModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        {
            provide: USER_SERVICE_STORAGE,
            useExisting: LOCAL_STORAGE
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}
